import React from 'react';
import { RaiseSignOffForm } from '../../pages/chat/ChatMessage/SubHeader/RaiseSignoff';
import { getPavMilestoneLabel } from './pavConfig';

export default function PavRaiseSignOffView({ ticket, milestone, isChat, onBack }) {
    return (
        <div className={`flex min-h-0 flex-1 flex-col bg-slate-50 ${isChat ? 'h-[40vh]' : ''}`}>
            <div className='flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3 shadow-sm'>
                <div className='flex min-w-0 items-center gap-3'>
                    <button
                        type='button'
                        onClick={onBack}
                        className='flex h-9 shrink-0 items-center gap-1 rounded-lg border border-scogoddd bg-white px-3 text-sm font-medium text-scogo21 shadow-sm transition-colors hover:border-scogoprimary hover:bg-scogolightblue hover:text-scogoprimary'
                    >
                        <span className='material-icons text-lg'>arrow_back</span>
                        Back to PAV
                    </button>
                    <div className='min-w-0'>
                        <p className='truncate text-base font-medium text-scogo21'>Raise signoff</p>
                        <p className='truncate text-xs font-normal text-scogo70'>Add the closing details for {getPavMilestoneLabel(milestone)}</p>
                    </div>
                </div>
                <span className='hidden items-center gap-1.5 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700 sm:inline-flex'>
                    <span className='material-icons-outlined text-sm'>verified</span>
                    Asset verification
                </span>
            </div>

            <div className={`min-h-0 flex-1 overflow-y-auto ${isChat ? 'p-2' : 'p-4'}`}>
                <div className='mx-auto overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm'>
                    <div className='flex items-start gap-3 border-b border-slate-100 bg-slate-50 px-4 py-3'>
                        <span className='material-icons-outlined mt-0.5 text-xl text-scogoprimary'>assignment_turned_in</span>
                        <div>
                            <p className='text-sm font-medium text-scogo21'>Confirm milestone completion</p>
                            <p className='mt-0.5 text-xs font-normal text-scogo70'>Your asset entries remain saved in this form. Use Back to PAV at any time to continue editing them.</p>
                        </div>
                    </div>
                    <RaiseSignOffForm
                        selectedMilestone={milestone}
                        ticketId={ticket?.id || ticket?.ticket_id}
                        formName={`pav_raise_signoff_${milestone?.id}`}
                        org_id={ticket?.org_id}
                        helpdesk_id={ticket?.helpdesk_id}
                        onCancel={onBack}
                        onSuccess={onBack}
                        closeModalOnSuccess={false}
                        cancelButtonText='Back to PAV'
                        submitContainerClassName='sticky bottom-0 z-10 flex justify-end gap-3 border-t border-slate-200 bg-white px-4 py-3 shadow-[0_-4px_12px_rgba(15,23,42,0.05)]'
                    />
                </div>
            </div>
        </div>
    );
}
